import React from 'react';
import { Collection } from '../game/levels';

interface CollectionSelectorProps {
  collections: Collection[];
  currentCollection: string;
  onSelectCollection: (collection: string) => void;
}

export const CollectionSelector: React.FC<CollectionSelectorProps> = ({
  collections,
  currentCollection,
  onSelectCollection,
}) => {
  return (
    <div style={styles.container}>
      <span style={styles.label}>Collection:</span>
      <select
        value={currentCollection}
        onChange={(e) => onSelectCollection(e.target.value)}
        style={styles.select}
      >
        {collections.map((collection) => (
          <option key={collection.name} value={collection.name}>
            {collection.name} ({collection.levels.length} levels)
          </option>
        ))}
      </select>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '20px',
  },
  label: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333',
  },
  select: {
    padding: '8px 12px',
    fontSize: '16px',
    borderRadius: '4px',
    border: '2px solid #4a4a4a',
    cursor: 'pointer',
    backgroundColor: '#fff',
  },
};